import Image from '@components/Image'
import { ElementHTML } from '@helpers/helper.rendering'
import { Link } from 'gatsby'
import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { RealEstateDataPageComponentData } from 'types'

const AboutUs2 = (props: RealEstateDataPageComponentData) => {
  const icons = ['building', 'investment', 'hand-shake', 'note']
  const { global_data } = props
  const {
    title,
    subtitle,
    items,
    button,
    underlineMode,
    titleElement,
    subtitleElement,
    backgroundSecondary,
    backgroundColor,
    backgroundHexa,
    paragraphColor,
    paragraphHexa,
    subtitleHexa,
    titleHexa,
    is_short,
  } = props

  const icons_style = global_data.pageConfig.design.icons
  const icon =
    icons_style === 'Solid' || icons_style === 'Light' ? `-${icons_style.toLowerCase()}` : ''

  return (
    <section
      style={{
        backgroundColor: backgroundHexa,
      }}
      className={
        'about-us bc p-y-config b ' +
        (backgroundSecondary && !backgroundColor ? 'bg-gray' : '') +
        (' ' + backgroundColor)
      }
    >
      <Container fluid>
        <Row className="d-flex align-items-start">
          <Col lg={2}>
            {/* AHORA */}
            <ElementHTML
              children={title!}
              elementType={titleElement || 'p'}
              className={'section-name'}
              style={{ color: titleHexa }}
            />
          </Col>
          <Col lg={10}>
            {subtitle && (
              <div className="sub-section ">
                {subtitle.split('\n').map((subtitle_, index) => (
                  <ElementHTML
                    key={index}
                    children={subtitle_!}
                    elementType={subtitleElement || 'h5'}
                    className={'d-block'}
                    style={{ color: subtitleHexa }}
                  />
                ))}
              </div>
            )}
          </Col>
          {button?.link && (
            <Col
              xs={10}
              lg={{ offset: 2 }}
            >
              <Link
                to={button?.link!}
                className="btn"
                style={{
                  background: button?.backgroundColor,
                  border: '1px solid ' + button?.borderColor,
                  color: button?.valueColor,
                }}
              >
                {button?.value}
              </Link>
            </Col>
          )}
          <Col
            lg={{ span: 10, offset: 2 }}
            className={items?.length === 0 ? 'd-none' : ''}
          >
            <Row className="items">
              {items?.map((item, index) =>
                index % 2 === 0 ? (
                  <Col
                    key={index}
                    xs={10}
                    lg={6}
                    className="d-flex ss item-both align-items-start"
                  >
                    {item.image_gatsby ? (
                      <Image
                        className={''}
                        objectFit={'cover'}
                        alt="icono"
                        image={item.image_gatsby!}
                      />
                    ) : (
                      <i
                        className={
                          `icon-${icons[index]}${icon}` + (underlineMode ? ' border ' : ' border  ')
                        }
                      ></i>
                    )}
                    <p
                      style={{ color: paragraphHexa }}
                      className={paragraphColor}
                    >
                      {is_short ? ( //Titulo bold ?
                        <>
                          <strong>{item.paragraph?.split(':')[0]}</strong>
                          {item.paragraph?.split(':')[1]}
                        </>
                      ) : (
                        item.paragraph
                      )}
                    </p>
                  </Col>
                ) : (
                  <Col
                    key={index}
                    xs={{ span: 10, offset: 2 }}
                    lg={{ span: 6, offset: 0 }}
                    className="d-flex item-both align-items-start"
                  >
                    {item.image_gatsby ? (
                      <Image
                        className={''}
                        objectFit={'cover'}
                        alt="icono"
                        image={item.image_gatsby!}
                      />
                    ) : (
                      <i
                        className={
                          `icon-${icons[index]}${icon}` + (underlineMode ? ' border ' : ' border ')
                        }
                      ></i>
                    )}
                    <p
                      style={{ color: paragraphHexa }}
                      className={paragraphColor}
                    >
                      {is_short ? ( //Titulo bold ?
                        <>
                          <strong>{item.paragraph?.split(':')[0]}</strong>
                          {item.paragraph?.split(':')[1]}
                        </>
                      ) : (
                        item.paragraph
                      )}
                    </p>
                  </Col>
                ),
              )}
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default AboutUs2
